import { Drawer as AnvilDrawer } from '@servicetitan/design-system';
import { DrawerWrapper } from './Drawer.styled';

type DrawerProps = React.ComponentProps<typeof AnvilDrawer> & {
  backdropOpacity?: number;
};

/**
 * Renders the Anvil Drawer component with custom styles.
 *
 * @param backdropOpacity - Opacity Percentage for the backdrop. It does not work with portal={true}
 */
export function Drawer({ backdropOpacity = 0, ...props }: DrawerProps) {
  return (
    <DrawerWrapper $backdropOpacity={backdropOpacity}>
      <AnvilDrawer backdrop portal={false} {...props} />
    </DrawerWrapper>
  );
}

export default Drawer;
